import React, { useEffect } from 'react';
import { useLocation } from '@reach/router';
import _ from "lodash";
import { Container, Row, Col, Breadcrumb } from "react-bootstrap"
import { Link } from "gatsby"

import "../scss/form-template.scss"

import Layout from "../components/Layout"
import Banner from "../components/Banner/Banner"
import Info from "../components/Info/Info"
import WhyChoose from "../components/Counter/WhyChoose";
import TrustpilotReviews from "../components/TrustpilotReviews/TrustpilotReviews";
import Features from "../components/Features/Features";
import Customer from "../components/Customer/Customer";
import TextImageBlock from "../components/TextImageBlock/TextImageBlock";
import LocalExperience from "../components/LocalExperience/LocalExperience"
import FAQ from "../components/Faq/Faq"
import Journey from "../components/Journey/Journey";


import { breadcrumbs } from "../common/utils/breadcrumbs";

const FormTemplate = (props) =>{

  const location = useLocation();

  var GQLPage = props.GQLPage;
  var GQLModules = props.GQLModules;

  let pathname = GQLPage?.menu?.slug ? GQLPage?.menu?.slug.replace(/-/g, '_') : "";

  const breadcrumbsList = breadcrumbs(GQLPage.menu);

  return(
    <div className={`form_template`}>
        <Layout seo_meta={GQLPage.seo_meta} menu_slug={GQLPage?.menu?.slug} popular_search={GQLPage?.menu?.popular_search} GQLPage={props.GQLPage}>
          
          <div className="breadcrumb-section">
            <Container>
                <Breadcrumb>
                    {/* <Breadcrumb.Item href="javascript:;" className="d-none">Back to Branch Details</Breadcrumb.Item> */}
                    <li className="breadcrumb-item"><Link to={'/'}>Home</Link></li>

                    {breadcrumbsList?.map((breadcrumb, i, arr) => {
                        if (arr.length - 1 === i) { // is the last item in the array
                            return (
                                <Breadcrumb.Item key={i} active>{breadcrumb.label}</Breadcrumb.Item>
                            )
                        } else {
                            return (
                                <li className="breadcrumb-item"><Link to={`${breadcrumb.url}/`}>{breadcrumb.label}</Link></li>
                            )
                        }
                    })}
                </Breadcrumb>
            </Container>
          </div>

          <Banner banner_section = {GQLPage?.banner_section} GQLModules={GQLModules} GQLPage={GQLPage} location={props.location} /> 


          {GQLModules?.length > 0 && GQLModules?.map((Module, index) => {
            return(
                <>
                    {Module.__typename === "GLSTRAPI_ComponentComponentsWhyChooseComponent" && <WhyChoose key={Module} Module={Module} /> }

                    {Module.__typename === "GLSTRAPI_ComponentComponentsTrustpilotComponent" && <TrustpilotReviews key={Module} Module={Module} />}

                    {Module.__typename === "GLSTRAPI_ComponentComponentsShowFeaturedProperty" && Module.show && <Features key={Module} Module={Module} menu_slug={GQLPage?.menu?.slug}/> }

                    {Module.__typename === "GLSTRAPI_ComponentComponentsHomeTilesComponent" && <Info key={Module} Module={Module} GQLPage={GQLPage} pathname={pathname} /> }

                    {Module.__typename === "GLSTRAPI_ComponentComponentsVideoSection" &&  <Customer key={Module} Module={Module} GQLPage={GQLPage}/>}

                    {Module.__typename === "GLSTRAPI_ComponentComponentsTextBlockWithImage" &&  <TextImageBlock key={Module} Module={Module} GQLPage={GQLPage}/>}

                    {Module.__typename === "GLSTRAPI_ComponentComponentsLocalExperience" && <LocalExperience key={Module} Module={Module} GQLPage={GQLPage}/>}

                    {Module.__typename ==="GLSTRAPI_ComponentComponentsFaq" && 
                    <section className={`faq_section ${Module?.faq_bg}`} id="faqs">
                        <Container>
                            <Row>
                                <Col><FAQ key={Module} Module={Module} /></Col>
                            </Row>
                        </Container>
                    </section>
                    }
                    

                    {Module.__typename === "GLSTRAPI_ComponentComponentsShowPropertyJourney" && Module.show && <Journey key={Module} Module={Module} />}
                </>                
            )
          })}
                       
        </Layout>
    </div>
  )

}

export default FormTemplate